import { FOOTER_TYPES } from '@monofront/business/constants';
import DefaultFooter from './DefaultFooter';
import LightFooter from './LightFooter';

interface IFooterProps {
  type?: FOOTER_TYPES;
}

const Footer: React.FC<IFooterProps> = ({ type }) => {
  switch (type) {
    case FOOTER_TYPES.DEFAULT:
      return <DefaultFooter />;
    case FOOTER_TYPES.LIGHT:
      return <LightFooter />;
    default:
      return <DefaultFooter />;
  }
};

export default Footer;
